export const ASSISTANT_DIALOGUES = {
    CREATE_EDIT: 'assistant',
    CONFIRMATION: 'alert'
};

export const assistantConfigColumns = [
    { id: 'name', label: 'Name' }
];
